import { StyledTd } from "./baseTd.jsx";

export const TextCell = (props: { text: string; className: string }) => {
  const cell = <StyledTd class={props.className}>{props.text}</StyledTd>;
  return cell;
};
